var map = {
	"./factfile_badge_highlight.json": [
		21071,
		1071
	],
	"./factfile_characters-and-pets.json": [
		61681,
		1681
	],
	"./factfile_creatures.json": [
		68045,
		8045
	],
	"./factfile_locations.json": [
		56695,
		6695
	],
	"./factfile_magical-miscellany.json": [
		33137,
		3137
	],
	"./factfile_objects.json": [
		37560,
		7560
	],
	"./factfile_plants-and-potions.json": [
		48888,
		8888
	],
	"./factfile_spells.json": [
		16140,
		6140
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4036;
module.exports = webpackAsyncContext;